<!-- Modals -->
<ui-confirmation-dialog
    header="employees.tasks-template.deleteTemplate"
    primaryButtonLabel="delete"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    #confirmDeleteModal
>
    <p>{{ 'employees.tasks-template.deleteConfirmation' | translate: { templateName: taskTemplate?.name } }}</p>
</ui-confirmation-dialog>

<!-- Delete task modal -->
<ui-confirmation-dialog
    header="employees.tasks-template.deleteTask"
    primaryButtonLabel="delete"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    #confirmDeleteModal
>
    <p>{{ 'employees.tasks-template.deleteTaskConfirmation' | translate: { taskToBeDeleted } }}</p>
</ui-confirmation-dialog>

<!-- Task Details Modal -->
<app-deprecated-modal #taskDetailsModal [noBorder]="true">
    <app-task-details #taskDetails [employee]="employee" [task]="currentTask" (close)="onClose()"></app-task-details>

    <!-- Close button -->
    <div class="actions close-button flex justify-end">
        <ui-button type="ghost" (click)="onClose()">{{ 'employees.tasks-template.close' | appTranslate }}</ui-button>
    </div>
</app-deprecated-modal>

<!-- Bulk Employee Selector -->
<app-common-bulk-select-employee-dialog #selectEmployees headerText="Assign Employees">
    <!-- Banner -->
    <ui-banner variant="info" class="margin-y-1 align-banner-text padding-bottom-2">
        <p>{{ bulkEmployeeModalBannerCopy | appTranslate }}</p>
    </ui-banner>
</app-common-bulk-select-employee-dialog>

<!-- Body -->
<div class="content">
    <div class="ui basic segment" [class.loading]="isLoading">
        <app-header title="{{ taskTemplate.name }}" [backRoute]="backRoute" [back]="true" [contextMenu]="true">
            <div class="buttons" *ngIf="hasTaskPermission">
                <ui-button type="primary" (click)="onCreateTaskFromTemplate()">{{
                    'employees.tasks-template.applyTaskTemplate' | appTranslate
                }}</ui-button>
            </div>
            <app-context-item
                *ngIf="hasTaskPermission"
                label="{{ 'employees.tasks-template.remindAllIncomplete' | appTranslate }}"
                (click)="onRemindIncomplete()"
            >
            </app-context-item>
            <app-context-item
                *ngIf="hasTaskPermission"
                label="{{ 'employees.tasks-template.edit' | appTranslate }}"
                (click)="onEditTaskTemplate()"
            >
            </app-context-item>
            <app-context-item
                *ngIf="hasTaskPermission"
                label="{{ 'employees.tasks-template.delete' | appTranslate }}"
                (click)="onDeleteTaskTemplate()"
            ></app-context-item>
        </app-header>
        <div class="ui segment">
            <app-segment-header
                title="{{ 'employees.tasks-template.taskTemplateDetails' | appTranslate }}"
            ></app-segment-header>
            <div class="app-grid">
                <div class="columns-3 margin-bottom-3">{{ 'employees.tasks-template.taskType' | appTranslate }}</div>
                <div class="columns-9 margin-bottom-3">{{ taskTemplate?.taskType | capitalize }}</div>
                <div class="columns-3 margin-bottom-3">{{ 'employees.tasks-template.dueDate' | appTranslate }}</div>
                <div class="columns-9 margin-bottom-3">{{ taskTemplate?.dueAt }}</div>
                <div class="columns-3 margin-bottom-3">{{ 'employees.tasks-template.requiredFor' | appTranslate }}</div>
                <div class="columns-9 margin-bottom-3">{{ taskTemplate?.requiredForLabel | appTranslate }}</div>
                <div class="columns-3 margin-bottom-3">
                    {{ 'employees.tasks-template.toBeCompletedBy' | appTranslate }}
                </div>

                <div *ngIf="!hasAssignees" class="columns-9 margin-bottom-3">{{ assignedToLabel | appTranslate }}</div>
                <div *ngIf="hasAssignees" class="columns-9">
                    <app-inline-avatars
                        numberOfEmployeesToShow="5"
                        [employees]="taskTemplate.assignees"
                    ></app-inline-avatars>
                </div>

                <ng-container *ngIf="taskTemplate.description">
                    <div class="columns-3 margin-bottom-3">
                        {{ 'employees.tasks-template.taskDescription' | appTranslate }}
                    </div>
                    <div class="columns-9 margin-bottom-3">
                        <span [innerHTML]="taskTemplate?.description | sanitizeHtml"></span>
                    </div>
                </ng-container>

                <ng-container *ngIf="taskTemplate.subtasks.length > 0">
                    <div class="columns-3 margin-bottom-3">
                        {{ 'employees.tasks-template.subtasks' | appTranslate }}
                    </div>
                    <div class="columns-9 margin-bottom-3">
                        <ul class="margin-top-0 padding-left-2">
                            <li *ngFor="let subtask of taskTemplate.subtasks">{{ subtask.description }}</li>
                        </ul>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <!-- Tasks index table -->
    <div class="ui basic segment tasks-table">
        <app-table
            title="{{ 'employees.tasks-template.taskLog' | appTranslate }}"
            [table]="tasksTable"
            (rowClicked)="onRowClicked($event)"
            (menuItemSelected)="onTableMenuEvent($event)"
        >
            <div class="empty">
                <img class="empty-icon" src="/assets/illustrations/cup.png" />
                <h2 class="ui centered header">
                    {{ 'employees.tasks-template.noTasksCurrentlyExist' | appTranslate }}
                </h2>
            </div>
        </app-table>
    </div>
</div>
